import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PostShipState {
  postShipData: any;
  // ... other state properties
}

const initialState: PostShipState = {
  postShipData: {},
  // ... other initial state
};

const postShipSlice = createSlice({
  name: 'postShip',
  initialState,
  reducers: {
    setPostShipData: (state, action: PayloadAction<any>) => {
      state.postShipData = action.payload;
    },
    // ... other reducers
  }
});

export const { setPostShipData } = postShipSlice.actions;
export default postShipSlice.reducer; 